import $ from "jquery";
import {updatePage} from "./page-summary";

export default function () {
    let removeItem = null;
    if ($('.item-remove').length) {
        $('body').on('click', '.item-remove', function () {
            removeItem = $(this).parents('.accordion-item').find('.accordion-collapse').data("id");
        });
    }

    const $removeModal = $('#removeModal');
    const $confirm = $removeModal.find('.confirm');
    const $dismiss = $removeModal.find('.dismiss');
    $confirm.on('click', function () {
        $dismiss.trigger('click');
        remove(removeItem);
    });
}

function remove(removeItem) {
    $.ajax({
        url: removeProductUrl,
        method: "POST",
        data: {
            id: removeItem
        },
        success: function (result) {
            $("#summary-data").replaceWith('<div id="loading" class="text-center">\n' +
                '<span class="loader mb-8"></span>\n' +
                '</div>');
            updatePage();
            window.$registrationData = result;
            if (window.$registrationData.products.length === 0) {
                location.reload();
            }
        },
        error: function (xhr) {
        }
    });
}
